import { AxiosInstance } from 'axios';
import { CreateOrderParams } from '../../types/apiType';

class OrderService {
  constructor(private ApiClient: AxiosInstance) {}

  createOrder = async (params: CreateOrderParams) => {
    const { data } = await this.ApiClient.post('/order', params);
    return data;
  };

  preOrder = async (params: Omit<CreateOrderParams, 'qty'>) => {
    const { data } = await this.ApiClient.get('/order/pre', { params });
    return data;
  };

  getOrders = async () => {
    const { data } = await this.ApiClient.get('/order');
    return data;
  };

  getInvoice = async (params: { sessionId: string }) => {
    const { data } = await this.ApiClient.get('/order/invoice', { params });
    return data;
  };

  getBilling = async (params: { sessionId: string }) => {
    const { data } = await this.ApiClient.get('/order/billing', { params });
    return data;
  };

  getCheckoutSession = async (params: { sessionId: string }) => {
    const { data } = await this.ApiClient.get('/order/checkout-session', { params });
    return data;
  };
}

export default OrderService;
